(() => {
  const popup = document.querySelector('[data-rdf-email-popup]');
  if (!popup) return;

  const dialog = popup.querySelector('dialog');
  const closeButton = popup.querySelector('[data-rdf-email-popup-close]');
  const copyButton = popup.querySelector('[data-rdf-copy-code]');
  const storageKey = 'rituel-email-popup-seen-v1';
  const delay = Number(popup.dataset.delay || 15000);
  const startsAt = new Date(popup.dataset.startsAt || 0).getTime();
  const hasSuccess = Boolean(popup.querySelector('[data-rdf-email-popup-success]'));
  const hasError = Boolean(popup.querySelector('[data-rdf-email-popup-error]'));

  const open = () => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    if (!hasSuccess && !hasError) localStorage.setItem(storageKey, 'true');
  };

  const close = () => {
    if (dialog?.open) dialog.close();
    localStorage.setItem(storageKey, 'true');
  };

  closeButton?.addEventListener('click', close);
  dialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = copyButton.dataset.rdfCopyCode;
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch {
        const textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.append(textArea);
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }
      copyButton.classList.add('is-copied');
      copyButton.querySelector('span')?.replaceChildren('Kopyalandı');
    });
  }

  if (hasSuccess || hasError) {
    window.setTimeout(open, 50);
    return;
  }
  if (localStorage.getItem(storageKey)) return;
  if (startsAt && Date.now() < startsAt) return;
  window.setTimeout(open, delay);
})();
